// extracted by mini-css-extract-plugin
export default {"date":"styles_date__IVZj7"};